export function restrictNonNumericalInput(event: KeyboardEvent): void {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
}

export function removeLeadingZero(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (input.value.length > 1 && input.value.startsWith('0')) {
    input.value = input.value.replace(/^0+/, '');
  }
}
